import { localized } from "../locales";
import { getUnitTranslationKey, guardString } from "../strings";
import type { ArticleListItem, Nullable } from "../types";

/**
 * The four fields the size string is built from. Named as a subset rather than taking a whole
 * article, so a picking line — which carries these and little else of the catalogue — can use it
 * without pretending to be an `ArticleListItem`.
 */
type ArticleSizeFields = Pick<ArticleListItem, "width" | "depth" | "height" | "sizeUnit">;

export function getArticleSizeString(article: Nullable<ArticleSizeFields>) {
	if (!article?.sizeUnit) return guardString(null);
	const width = { value: article?.width, prefix: localized("calculations.width_short") };
	const depth = { value: article?.depth, prefix: localized("calculations.depth_short") };
	const height = { value: article?.height, prefix: localized("calculations.height_short") };
	const sizeUnit = article?.sizeUnit;

	const arr = [width, depth, height].filter((dim) => dim.value !== null && dim.value !== undefined);

	if (arr.length === 0) return guardString(null);

	return `${arr.map((dim) => `${dim.prefix}${dim.value}`).join(" × ")} ${localized(getUnitTranslationKey(sizeUnit))}`;
}
